import styled from "styled-components"

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
    vertical-align: top;
    flex-direction: column;
`

export const Content = styled.div`
    display: flex;
    align-items: center;
    vertical-align: top;
    flex-direction: column;
    justify-content: space-around;
`